"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DOT_SIZE = '12px';

var DefaultDot = _styledComponents["default"].div.withConfig({
  displayName: "dots__DefaultDot",
  componentId: "sc-1326u8c-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n    height:  ", ";\n    border-radius: 50%;\n    background: ", ";\n    opacity: ", ";\n    margin: 0 5px;\n    cursor: pointer;\n    &:hover {\n        opacity: ", ";\n    }\n"])), DOT_SIZE, DOT_SIZE, _constants.COLORS.darkGrey, function (props) {
  return props.active ? 0.8 : 0.2;
}, function (props) {
  return props.active ? 1 : 0.45;
});

var DotsContainer = _styledComponents["default"].div.withConfig({
  displayName: "dots__DotsContainer",
  componentId: "sc-1326u8c-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    justify-content: center;\n    position: absolute;\n\n    ", "\n"])), function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? "\n            height: 100%;\n            margin-left: 10px;\n            right: -30px;\n            flex-direction: column;\n            \n            & ".concat(DefaultDot, " {\n                margin: 5px 0;\n            }\n        ") : "\n            width: 100%;\n            margin-top: 10px;\n            bottom: 26px;\n            z-index: 10;\n        ";
});

var DefaultDots = function DefaultDots(props) {
  var active = props.active,
      count = props.count,
      _onClick = props.onClick,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? false : _props$vertical;
  var dots = [];

  var _loop = function _loop(i) {
    dots.push( /*#__PURE__*/_react["default"].createElement(DefaultDot, {
      key: i,
      active: i === active,
      onClick: function onClick() {
        return _onClick(i);
      }
    }));
  };

  for (var i = 0; i <= count; i++) {
    _loop(i);
  }

  return /*#__PURE__*/_react["default"].createElement(DotsContainer, {
    vertical: vertical
  }, dots);
};

var _default = DefaultDots;
exports["default"] = _default;